// firebase
export const VUUR = 'AIzaSyBCHS2KAKlzGMoxR-eaN5lkkSls-BRXHdk';

// tvdb
export const TVDB_SLEUTEL = 'W1VZTTXHOTS0OECP';
export const TVDB_USERKEY = 'HI124OZP2ARTMC9H';
export const TVDB_USERNAME = 'djdoamgy';

//the movie database
export const TMDB_SLEUTEL = '726cf06ac38778408ca7db20c885eebd';

//filestack - djdoa account
export const FILESTACK_SLEUTEL = 'A3uqFGYuXRlIC5u1iuBgqz';